import { h, render, Component } from 'preact';
import { Wizard } from './wizard';

export class SecondFactorForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      focuskey: '',
      errMsg: '',
      errVisible: false,
      loading: false,
      awaitingOTP: false,
      otp: '',
      selectedDevice: '',
      secondFactorDevices: {}
    }

    this.fetchFactors();

  }

  fetchFactors = () => {
    var me = this;

    fetch("/api/v1/devices")
    .then( resp => {
      return resp.json();
    })
    .then( data => {
      me.setState({
        secondFactorDevices: data.devices,
        selectedDevice: Object.keys(data.devices)[0]
      })
    });
  }

  clearErr() {
    if(this.state.errMsg || this.state.errVisible) {
      this.setState((prevState, props) => ({
        errMsg: '',
        errVisible: false
      }));
    }
  }

  chooseFactor = e => {
    e.target.classList.add('disabled'); 
    let authType = e.target.getAttribute('auth-type');
    if(authType != 'mobile_otp') {
      let logo = document.getElementsByClassName('logo-target')[0];
      logo.classList.add('loading');
      fetch(
        "/api/v1/second-factor",
        {
          method:"POST",
          body:JSON.stringify({"authType": authType, "deviceID": this.state.selectedDevice}),
          headers:{"Content-Type":"application/json"}
        }
      ).then( resp => {
        logo.classList.remove('loading');
        if(resp.ok) {
          resp.json()
          .then(({redirectUrl, ...data}) => location = redirectUrl)
          .catch(e => console.error(e))
        }
      });
    } else {
      this.setState((prevState, props) => ({
        awaitingOTP: true
      }))
    }
  }

  submitOTP = e => {
    var me = this;
    me.setState((prevState, props) => ({
      otp: e.target.value
    }));
    me.clearErr();
    // auto submit if 6 characters long
    if(e.target.value.length >= 6) {
      me.setState((prevState, props) => ({
        loading: true
      }));
      let logo = document.getElementsByClassName('logo-target')[0];
      logo.classList.add('loading');
      fetch(
        "/api/v1/second-factor",
        {
          method:"POST",
          body:JSON.stringify({
            "authType": "mobile_otp", 
            "deviceID": me.state.selectedDevice,
            "passcode": e.target.value}),
          headers:{"Content-Type":"application/json"}
        }
      ).then( resp => {
        logo.classList.remove('loading');
        me.setState((prevState, props) => ({
          loading: false
        }));
        if(resp.ok) {
          resp.json()
          .then(({redirectUrl, ...data}) => location = redirectUrl)
          .catch(e => console.error(e))
        } else {
          me.setState((prevState, props) => ({
            errMsg: <span>Your passcode was rejected.<br/>Please try again.</span>,
            errVisible: true,
            otp: ''
          }));
        }
      });
    }
  }

  showFactorChoices = e => {
    this.setState((prevState, props) => ({
      awaitingOTP: false,
      otp: '',
      errMsg: '',
      errVisible: false
    }));
  }

  render(props, state) {
    if(state.awaitingOTP) {
      // #####################
      // ### OTP Code Form ###
      var submitClass = 'locked';
      submitClass = state.errMsg?(state.errVisible?'error':'errHidden'):submitClass;
      submitClass = state.loading?'loading position-spin':submitClass;
      return (
        <span>
          <div id="passwordForm" class={'passwordFormAligner wizard '+(state.loading?'loading':'')}>
            <div>
              <div class={"floating-placeholder" + (state.focuskey == 'otp'?' float':'') + (state.otp != ''?' hidden':'')}>
                <input type="tel" id="otp" maxlength="6" value={state.otp}
                  onBlur={this.focus}
                  onFocus={this.focus}
                  onInput={this.submitOTP}
                  onChange={this.submitOTP}/>
                <label for="otp">Enter your 6 Digit Passcode</label>
              </div>
            </div>
            <div id="errMsg" class={state.errVisible?'':'hidden'}
              onClick={this.hideErr}>
              {state.errMsg}
            </div>
            <button type="button" onClick={this.submitOTP}
                  class={"circle-form-button "+submitClass} />
            <div id="input-outliner" class={state.focuskey}/>
          </div>
          <div id="desktopWizardBtns" style="text-align:center;">
            <div class="touchBtn" onClick={this.showFactorChoices}><i class="fa fa-arrow-left"></i>&nbsp;Try a Different 2 Factor Method</div>
          </div>
          <div id="mobileWizardBtns" class="touchOptions">
            <div class="touchBtn" onClick={this.showFactorChoices}><i class="fa fa-arrow-left"></i>&nbsp;Try a Different 2 Factor Method</div>
          </div>
        </span>
      )
    } else {
      // ##########################
      // ### Second Factor Form ###
      var deviceKeys = Object.keys(state.secondFactorDevices);
      var deviceSelector = '';
      if(deviceKeys.length > 1) {
        // add device selector html here
        deviceSelector = (
          <select style="width:100%">
            {deviceKeys.map((key, index) => (
              <option value={key} selected={state.selectedDevice==key}>{state.secondFactorDevices[key].name}</option>
            ))}
          </select>
        );
      }
      // example devices object
      // {NDVNADS984987D9HASD9: {capabilities: ["auto", "push", "sms", "phone", "mobile_otp"], name: "iOS (XXX-XXX-1234)"}}
      // console.log(state.selectedDevice, state.secondFactorDevices);
      var availCapes = '';
      if(state.selectedDevice)
        availCapes = state.secondFactorDevices[state.selectedDevice].capabilities;
      var factorOptionBtns = (
        <div class="touchOptions">
          {availCapes.includes('push')?<div class="touchBtn" auth-type="push" onClick={this.chooseFactor}><span class="fa-stack fa-lg"><i class="fa fa-comment-o fa-stack-2x"></i><i class="fa fa-bell-o fa-stack-1x"></i></span><div>Push<br/> (recommended)</div></div>:''}
          {availCapes.includes('mobile_otp')?<div class="touchBtn" auth-type="mobile_otp" onClick={this.chooseFactor}><span class="fa-stack fa-lg"><i class="fa fa-tablet fa-stack-2x"></i><i style="font-size:.7em;top:-.1em;" class="fa fa-history fa-stack-1x"></i></span><div>Passcode</div></div>:''}
          {availCapes.includes('phone')?<div class="touchBtn" auth-type="phone" onClick={this.chooseFactor}><span class="fa-stack fa-lg"><i class="fa fa-volume-control-phone fa-stack-2x"></i></span><div>Call Me</div></div>:''}
        </div>
      );

      return (
        <Wizard title="Choose Your Second Factor">
          {deviceSelector}
          {factorOptionBtns}
        </Wizard>
      )
    }
  }
}
